import React, { useEffect, useRef, useState } from "react";
import axiosInstance from "../../../axiosInstance";
import Sidebar from "../../components/Sidebar";
import Navbar from "../../components/Navbar";
import LoadingScreen from "../../components/LoadingScreen";

const LiveUser = () => {
  const mapRef = useRef(null);
  const mapInstance = useRef(null); // Store map instance
  const markersRef = useRef({}); // Store markers by user ID
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  const onlineIcon = "http://maps.google.com/mapfiles/ms/icons/green-dot.png";
  const offlineIcon = "http://maps.google.com/mapfiles/ms/icons/red-dot.png";

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const res = await axiosInstance.get(
          "/all-employee?type=1&longitude=&latitude=&empType=2"
        );
        const userList = res.data.users || [];
        setUsers(userList);
        setLoading(false);

        if (window.google) {
          initGoogleMap(userList);
        } else {
          console.error("Google Maps API not loaded");
        }
      } catch (error) {
        console.error("Failed to load users", error);
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  const initGoogleMap = (userList) => {
    if (!mapRef.current) return;

    const firstUser = userList[0];
    const center = firstUser
      ? {
          lat: parseFloat(firstUser.latitude),
          lng: parseFloat(firstUser.longitude),
        }
      : { lat: 28.6139, lng: 77.2090 };

    const map = new window.google.maps.Map(mapRef.current, {
      center,
      zoom: 13,
    });

    mapInstance.current = map;

    userList.forEach((user) => {
      const lat = parseFloat(user.latitude);
      const lng = parseFloat(user.longitude);
      if (isNaN(lat) || isNaN(lng)) return;

      const marker = new window.google.maps.Marker({
        position: { lat, lng },
        map,
        title: user.username,
        icon: user.online === 1 ? onlineIcon : offlineIcon,
      });

      const infoWindow = new window.google.maps.InfoWindow({
        content: `<strong>${user.username}</strong><br>Status: ${
          user.online ? "🟢 Online" : "🔴 Offline"
        }`,
      });

      marker.addListener("click", () => {
        infoWindow.open(map, marker);
      });

      markersRef.current[user._id] = {
        marker,
        infoWindow,
      };
    });
  };

  const handleUserClick = (userId) => {
    const userMarker = markersRef.current[userId];
    if (userMarker && mapInstance.current) {
      const marker = userMarker.marker;
      const infoWindow = userMarker.infoWindow;

      mapInstance.current.panTo(marker.getPosition());
      mapInstance.current.setZoom(17);
      infoWindow.open(mapInstance.current, marker);
    }
  };

  const showAllUsersOnMap = () => {
    const bounds = new window.google.maps.LatLngBounds();
    Object.values(markersRef.current).forEach(({ marker }) => {
      bounds.extend(marker.getPosition());
    });

    if (mapInstance.current && !bounds.isEmpty()) {
      mapInstance.current.fitBounds(bounds);
    }
  };

  return (
    <>
      <Sidebar />
      <main className="content">
        <Navbar />
        <div className="py-4 px-4">
          <h2>Live Maids</h2>
          {loading ? (
            <LoadingScreen />
          ) : (
            <div className="row">
              {/* Left Column - User List */}
              <div className="col-md-4" style={{ maxHeight: "500px", overflowY: "auto" }}>
                <div className="mb-2">
                  <button
                    onClick={showAllUsersOnMap}
                    className="btn btn-primary btn-sm w-100"
                  >
                    🔍 Show All Users on Map
                  </button>
                </div>
                <div className="list-group">
                  {users.map((user) => (
                    <button
                      key={user._id}
                      onClick={() => handleUserClick(user._id)}
                      className={`list-group-item list-group-item-action d-flex justify-content-between align-items-center ${
                        user.online ? "list-group-item-success" : "list-group-item-light"
                      }`}
                    >
                      {user.username}
                      <span
                        className={`badge rounded-pill ${
                          user.online ? "bg-success" : "bg-secondary"
                        }`}
                      >
                        {user.online ? "Online" : "Offline"}
                      </span>
                    </button>
                  ))}
                </div>
              </div>

              {/* Right Column - Map */}
              <div className="col-md-8">
                <div
                  ref={mapRef}
                  style={{
                    height: "500px",
                    width: "100%",
                    borderRadius: "10px",
                    border: "1px solid #ccc",
                  }}
                />
              </div>
            </div>
          )}
        </div>
      </main>
    </>
  );
};

export default LiveUser;
